<template>
    <page-container>
        <page-header>
            {{ pageTitle }}
            <template v-slot:actions>
                <analytics-controls v-model="controls" :groupId="props.groupId" />
            </template>
        </page-header>

        <div class="grid gap-6 grid-cols-1 lg:grid-cols-12">
            <analytics-daily-new-contacts-subscribers-unsubscribers
                class="lg:col-span-12"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            >
            </analytics-daily-new-contacts-subscribers-unsubscribers>

            <analytics-contacts-total-created
                class="lg:col-span-4"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            >
            </analytics-contacts-total-created>
            <analytics-marketing-subscriptions-total-opt-ins
                class="lg:col-span-4"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            >
            </analytics-marketing-subscriptions-total-opt-ins>
            <analytics-marketing-subscriptions-total-opt-outs
                class="lg:col-span-4"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            >
            </analytics-marketing-subscriptions-total-opt-outs>

            <analytics-marketing-subscriptions-total-by-status
                class="lg:col-span-4"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            />
            <analytics-marketing-subscriptions-total-by-status
                class="lg:col-span-4"
                status="opt_in"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            />
            <analytics-marketing-subscriptions-total-by-status
                class="lg:col-span-4"
                status="unknown"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            />

            <analytics-daily-new-contacts
                class="lg:col-span-12"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
                :orgUnitId="props.orgUnitId"
                :groupId="props.groupId"
                :type="props.type"
            >
            </analytics-daily-new-contacts>
        </div>
    </page-container>
</template>
<script setup>
import { computed, ref } from 'vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import AnalyticsControls from './partial/AnalyticsControls.vue';
import AnalyticsMarketingSubscriptionsTotalOptIns from './charts/time-series/AnalyticsMarketingSubscriptionsTotalOptIns.vue';
import AnalyticsMarketingSubscriptionsTotalOptOuts from './charts/time-series/AnalyticsMarketingSubscriptionsTotalOptOuts.vue';
import AnalyticsContactsTotalCreated from './charts/time-series/AnalyticsContactsTotalCreated.vue';
import AnalyticsMarketingSubscriptionsTotalByStatus from './charts/current/AnalyticsMarketingSubscriptionsTotalByStatus.vue';
import AnalyticsDailyNewContacts from './charts/time-series/AnalyticsDailyNewContacts.vue';
import AnalyticsDailyNewContactsSubscribersUnsubscribers from './charts/time-series/AnalyticsDailyNewContactsSubscribersUnsubscribers.vue';
import { controlDateRangeOptions } from '../../utils/analytics';

const props = defineProps({
    orgUnitId: {
        type: Number,
    },
    groupId: {
        type: String,
    },
    type: {
        type: String,
        default: undefined,
        validator: (type) => ['affiliated', 'preferred'].includes(type),
    },
});

const controls = ref(
    controlDateRangeOptions(Boolean(props.groupId), Boolean(props.orgUnitId)).find(
        (option) => option.value === 'last_30_days'
    )
);

const pageTitle = computed(() => {
    switch (props.type) {
        case 'affiliated':
            return 'Affiliated Contacts';
        case 'preferred':
            return 'Preferred Contacts';
        default:
            return 'Contacts';
    }
});
</script>
